__turbopack_context__.v({
  "close": "eWQFwW_close",
  "count": "eWQFwW_count",
  "empty": "eWQFwW_empty",
  "head": "eWQFwW_head",
  "list": "eWQFwW_list",
  "loading": "eWQFwW_loading",
  "modal": "eWQFwW_modal",
  "row": "eWQFwW_row",
  "rowAvatar": "eWQFwW_rowAvatar",
  "rowLink": "eWQFwW_rowLink",
  "rowName": "eWQFwW_rowName",
  "rowRole": "eWQFwW_rowRole",
  "rowText": "eWQFwW_rowText",
  "skeletonAvatar": "eWQFwW_skeletonAvatar",
  "skeletonName": "eWQFwW_skeletonName",
  "skeletonRole": "eWQFwW_skeletonRole",
  "skeletonRow": "eWQFwW_skeletonRow",
  "skeletonText": "eWQFwW_skeletonText",
  "title": "eWQFwW_title",
  "titleWrap": "eWQFwW_titleWrap",
});
